<template>
    <div>
        <el-popover
                placement="top-end"
                width="400"
                trigger="click"
        >
            <picker
                    :data="emojiIndex"
                    @select="addEmoji"
                    :showPreview="false"
            ></picker>
            <span class="mr-2" slot="reference">
                <el-tooltip content="Emoji" placement="top">
                    <a href="#"><i class="far fa-smile"></i></a>
                </el-tooltip>
            </span>
        </el-popover>
        <placeholders-picker @select="addPlaceholder">
            <el-tooltip content="Placeholders" placement="top">
                <a href="#"><i class="fas fa-code"></i></a>
            </el-tooltip>
        </placeholders-picker>
    </div>
</template>

<script>
  import {EmojiIndex, Picker} from 'emoji-mart-vue-fast';
  import PlaceholdersPicker from "./placeholder/index";
  import data from 'emoji-mart-vue-fast/data/apple';

  export default {
    components: {
      PlaceholdersPicker,
      Picker,
    },

    props: {
      disabled: {
        type: Boolean,
        default: false,
      }
    },

    data() {
      return {
        emojiIndex: new EmojiIndex(data),
      };
    },

    methods: {
      /**
       * @param {string} native
       */
      addEmoji({native}) {
        this.emitValue(native);
      },

      /**
       * @param {string} value
       */
      addPlaceholder(value) {
        this.emitValue(value);
      },

      /**
       * @param {string} value
       * @emits insert-value
       */
      emitValue(value) {
        !this.disabled && this.$emit('insert-value', value);
      },
    },
  }
</script>

